import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/solution/neirong.png'
import _imports_1 from '@/assets/images/solution/jishu.png'
import _imports_2 from '@/assets/images/solution/chengben.png'


const _hoisted_1 = { class: "education" }
const _hoisted_2 = { class: "fays" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "yycj" }
const _hoisted_5 = { class: "yycj-content" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "yyal" }
const _hoisted_8 = { class: "yyal-content" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "content" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "detail" }
const _hoisted_14 = { class: "pagination" }
const _hoisted_15 = ["onClick"]

import { ref, onMounted } from 'vue'
import { selectCommonElement } from '@/api'
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import { asynchronousRetrieval } from '@/utils'
import SubTitle from '@/components/SubTitle.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'EducationModel',
  setup(__props) {

const loadUrl: any = ref({})

const store = useStore()
const router = useRouter()
const casesList: any = ref([])
const casesListAll: any = ref([])
const paginationIndex = ref(0)
const paginationValue = ref(1)

const changeData = (value: number) => {
  paginationIndex.value = value - 1;
  casesList.value = [...casesListAll.value].slice((value - 1) * 5, value * 5)
}

const toDetail = (relatedHtmlId: number, title: string) => {
  router.push(`/details?relatedHtmlId=${relatedHtmlId}`)
  store.state.pageTitleStr = `解决方案 / 教育解决方案 / ${title}`
}

onMounted(async () => {
  // 条件判断：只有当数据为空时才请求接口
  // 因为父组件被 keep-alive 缓存，子组件也会被缓存
  // 再次进入页面时 onMounted 仍会执行，但数据已经存在，不需要重新请求
  if (casesListAll.value.length === 0) {
    selectCommonElement({ columnId: 4, appId: 2 }).then((res: any) => {
      casesListAll.value = [...res].filter(e => e.industry == 3).sort((a, b) => (a.sortNum || 0) - (b.sortNum || 0)) || []
      casesList.value = [...casesListAll.value].slice(paginationIndex.value * 5, (paginationIndex.value + 1) * 5)
      paginationValue.value = Math.ceil(casesListAll.value?.length / 5) || 0
    })
  }

  // 条件判断：只有当图片未加载时才请求图片资源
  // 避免重复加载图片，保持缓存状态
  if (!loadUrl.value.fays_bg) {
    const fays_bg: any = await asynchronousRetrieval('nfznxr-images/jjfa/fays-bg.png');
    const educationMp4: any = await asynchronousRetrieval('webimg/gif/education.gif');
    loadUrl.value = { fays_bg, educationMp4 }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title-font-style" }, "教育解决方案", -1)),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "illustrate" }, [
      _createElementVNode("div", null, "针对教育行业课程创建教学场景和虚拟仿真课件，实现教学内容的场景化和教学质量的闭环管理，突出互动性和趣味性，达到高效、有趣、安全的教学效果。")
    ], -1)),
    _createVNode(SubTitle, { "title-text": "行业痛点" }),
    _cache[5] || (_cache[5] = _createElementVNode("div", null, [
      _createElementVNode("div", { class: "disadvantage" }, "数实结合的沉浸式教学体验可以实现对传统教学方式的变革，为教育行业带来全新的体验和机会。")
    ], -1)),
    _createVNode(SubTitle, { "title-text": "方案优势" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: loadUrl.value.fays_bg
      }, null, 8, _hoisted_3),
      _cache[2] || (_cache[2] = _createStaticVNode("<div data-v-6d09a9fe><div data-v-6d09a9fe><img src=\"" + _imports_0 + "\" data-v-6d09a9fe><div class=\"title\" data-v-6d09a9fe>内容优势</div><div class=\"content-text\" data-v-6d09a9fe>XR可视化培训相比传统方式，更为直观易学，有效缩短员工培训时间，提高培训效率。</div></div><div data-v-6d09a9fe><img src=\"" + _imports_1 + "\" data-v-6d09a9fe><div class=\"title\" data-v-6d09a9fe>技术优势</div><div class=\"content-text\" data-v-6d09a9fe>以互动性+趣味性打造XR虚拟仿真教学平台，实现课程“教-学-练-考”的闭环课程体系。</div></div><div data-v-6d09a9fe><img src=\"" + _imports_2 + "\" data-v-6d09a9fe><div class=\"title\" data-v-6d09a9fe>成本优势</div><div class=\"content-text\" data-v-6d09a9fe>通过虚拟教室和数字化教材，学校无需投入大量资金建设实体教室和购买物理教具，从而节省了大量基础设施和维护费用。</div></div></div>", 1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(SubTitle, { "title-text": "应用场景" }),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          src: loadUrl.value.educationMp4
        }, null, 8, _hoisted_6)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(SubTitle, { "title-text": "应用案例" }),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(casesList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            onClick: ($event: any) => (toDetail(item.relatedHtmlId, item.title))
          }, [
            _createElementVNode("img", {
              src: item.ossPath
            }, null, 8, _hoisted_10),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(item.title), 1),
              _createElementVNode("div", null, _toDisplayString(item.subTitle), 1),
              _createElementVNode("div", _hoisted_13, _toDisplayString(item.introduction), 1)
            ])
          ], 8, _hoisted_9))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", {
          class: "prev",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (changeData(Math.max(0, paginationIndex.value - 1) + 1)))
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginationValue.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => (changeData(item)),
            class: _normalizeClass(paginationIndex.value == index ? 'active' : ''),
            key: item
          }, _toDisplayString(item), 11, _hoisted_15))
        }), 128)),
        _createElementVNode("div", {
          class: "next",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (changeData(Math.min(paginationIndex.value + 1, paginationValue.value - 1) + 1)))
        })
      ])
    ])
  ]))
}
}

})